import React from "react"

const SvgSearch = (props) => (
  <svg viewBox="0 0 18 18" {...props}>
    <path
      d="M7.5 0A7.5 7.5 0 0115 7.5c0 1.7-.572 3.287-1.536 4.548l4.45 4.452-1.414 1.414-4.452-4.45A7.485 7.485 0 017.5 15a7.5 7.5 0 110-15zm0 2a5.5 5.5 0 100 11 5.5 5.5 0 100-11z"
      fillRule="evenodd"
    />
  </svg>
)

export default SvgSearch
